import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { BusinessSettingsLayout } from '@/components/business-settings/BusinessSettingsLayout';
import { Calendar, ArrowRight } from 'lucide-react';

export default function SchedulingSettings() {
  const navigate = useNavigate();

  return (
    <BusinessSettingsLayout
      title="Scheduling Settings"
      description="Configure scheduling rules, shift patterns, and workforce planning"
    >
      <div className="space-y-6">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Calendar className="h-5 w-5" />
              Shift Codes
            </CardTitle>
            <CardDescription>
              Manage shift codes for roster planning
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground mb-4">
              Configure shift codes like Day (D), Evening (E), Morning (M), and Night (N) that appear in your roster planner.
            </p>
            <Button onClick={() => navigate('/business-settings/shift-codes')}>
              Manage Shift Codes
              <ArrowRight className="h-4 w-4 ml-2" />
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Scheduling Rules</CardTitle>
            <CardDescription>
              Define scheduling constraints and business rules
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="text-center py-8 text-muted-foreground">
              <p>Scheduling rules configuration will be available here.</p>
              <p className="text-sm mt-2">This is a placeholder for future implementation.</p>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Workforce Planning</CardTitle>
            <CardDescription>
              Configure staffing requirements and coverage rules
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="text-center py-8 text-muted-foreground">
              <p>Workforce planning settings will be available here.</p>
              <p className="text-sm mt-2">This is a placeholder for future implementation.</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </BusinessSettingsLayout>
  );
}
